import React from 'react'
import Link from 'gatsby-link'
import ReactCardFlipper from 'gatsby-card-flipper'

const IndexPage = () => (
  <div style={{marginTop: '60px'}}>
    <p>
      React Card Flipper is a React component that can be triggered by hover or
      click. Inspired from <a href="https://davidwalsh.name/css-flip">David Walsh's great tutorial</a>.
      Take a look at the <a href="https://github.com/factor1/react-card-flipper/blob/master/README.md">documentation</a> for more information.
    </p>
    <div className="example-container">
      <div className="example">
        <h2>Standard Example</h2>
        <ReactCardFlipper width="300px" height="400px">
          <div>
            A standard card that can be clicked to initiate a flip.
          </div>
          <div>
            Great job!
          </div>
        </ReactCardFlipper>
      </div>

      <div className="example">
        <h2>Levitate Example</h2>
        <ReactCardFlipper width="300px" height="400px" levitate={true}>
          <div>
            A standard click card flip with <br /> <code>{`levitate={true}`}</code>
          </div>
          <div>
            Great job!
          </div>
        </ReactCardFlipper>
      </div>

      <div className="example">
        <h2>Hover Example</h2>
        <ReactCardFlipper width="300px" height="400px" behavior="hover">
          <div>
            A hover card flip using <br /> <code>{`behavior='hover'`}</code>
          </div>
          <div>
            Great job!
          </div>
        </ReactCardFlipper>
      </div>

      <div className="example">
        <h2>Sizing Example</h2>
        <ReactCardFlipper width="400px" height="400px">
          <div>
            A standard click card flip with width and height props. <br /> <code>{`width="400px" height="400px"`}</code>
          </div>
          <div>
            Great job!
          </div>
        </ReactCardFlipper>
      </div>

    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js